import KeyMirror from 'keymirror'

const DictTypes = KeyMirror({
	GET_LIST_DICT_WORD: null,
	SELECT_DICT_WORD: null,

	UPDATE_DICT_WORD: null,
	CREATE_DICT_WORD: null,
	DELETE_DICT_WORD: null,
	SELECT_DICT_WORD_TYPE: null,
	GET_ALL_DICT_WORD_TYPE: null,
	CREATE_DICT_WORD_TYPE: null,
	UPDATE_DICT_WORD_TYPE: null,
	DELETE_DICT_WORD_TYPE: null,
})

export default DictTypes
